import { CardOneButtonOutput, CardOneComponentConfig } from '..';

export interface CardOneListButtonClickOutput {
    cardOneButtonOutput: CardOneButtonOutput;
    item: CardOneComponentConfig;
}
